module.exports = __webpack_public_path__ + "contacts-cbf4f629/encoding-c671d723d48853ff8aba29a41d9c1ba6.svg";